export default {"src":"/_next/static/media/Document.1d8bc49a.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};